import configureStoreProd from './configureStore.prod'
import configureStoreDev from './configureStore.dev'

export default import.meta.env.PROD
  ? configureStoreProd
  : configureStoreDev
